import PropTypes from 'prop-types'
import { useContext } from 'react'
import { TableContext } from 'components/table/Table'
import classNames from 'classnames'
import { isPresent, noop } from 'utils'

const CheckboxColumn = () => {
  const { rows, setAllRows } = useContext(TableContext)
  const checkableRows = Object.values(rows).filter(
    row => !row.noCheckbox && !row.isDisabled
  )
  const allChecked =
    isPresent(checkableRows) && !checkableRows.some(row => !row.checked)
  return (
    <th scope="col" className="th_select align_c">
      <div className="inner_tbl">
        <div className="hide_shim" style={{ width: 36 }} />
        <label
          className={classNames('check_inp', {
            on: allChecked,
            in_active: !isPresent(checkableRows),
          })}>
          <input
            type="checkbox"
            name="inpCheckSet"
            className="inp_check"
            checked={allChecked}
            onChange={() => setAllRows(!allChecked)}
          />
          <span className="img_comm ico_check" />
        </label>
      </div>
    </th>
  )
}

const Column = ({
  className = '',
  thClassName = '',
  title,
  checkbox,
  minWidth,
  onClick = noop,
}) =>
  checkbox ? (
    <CheckboxColumn />
  ) : (
    <th scope="col" className={thClassName} onClick={onClick}>
      <div className={classNames('inner_tbl', className)}>
        {minWidth && <div className="hide_shim" style={{ width: minWidth }} />}
        {title}
      </div>
    </th>
  )

export default Column

Column.propTypes = {
  checkbox: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  minWidth: PropTypes.number,
  className: PropTypes.string,
  thClassName: PropTypes.string,
  title: PropTypes.node,
  onClick: PropTypes.func,
}
